<script setup lang="ts">
import type { TabsContentProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { TabsContent, useForwardProps } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<TabsContentProps & { class?: HTMLAttributes['class'] }>()

const delegated = reactiveOmit(props, 'class')
const forwarded = useForwardProps(delegated)
</script>

<template>
  <TabsContent
    v-bind="forwarded"
    :class="cn('pt-4 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-100', props.class)"
  >
    <slot />
  </TabsContent>
</template>
